import { render, staticRenderFns } from "./ItemFormRow.vue?vue&type=template&id=3a07f18e&scoped=true&lang=html"
import script from "./ItemFormRow.vue?vue&type=script&lang=js"
export * from "./ItemFormRow.vue?vue&type=script&lang=js"
import style0 from "./ItemFormRow.vue?vue&type=style&index=0&id=3a07f18e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a07f18e",
  null
  
)

export default component.exports